
import React from 'react';
import { LayoutDashboard } from 'lucide-react';
import { SunStatsWidget, QuickActions, WeatherWidget, ActivityFeed } from './widgets';

const StatsTab = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center space-x-3">
        <div className="p-2 bg-peach-orange/10 rounded-lg">
          <LayoutDashboard className="h-6 w-6 text-peach-orange" />
        </div>
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Dashboard Overview</h1>
          <p className="text-muted-foreground">
            Your sunny terrace experience at a glance
          </p>
        </div>
      </div>

      {/* Main Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Left Column - Main Stats */}
        <div className="lg:col-span-2 space-y-6">
          <SunStatsWidget />
          <WeatherWidget />
        </div>
        
        {/* Right Column - Actions & Activity */}
        <div className="space-y-6">
          <QuickActions />
          <ActivityFeed />
        </div>
      </div>
    </div>
  );
};

export default StatsTab;
